// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Evhl3","bigColWidth":"Table_bigColWidth__2Eu_v","biggerColWidth":"Table_biggerColWidth__uqsde","row":"Table_row__2jauz","col":"Table_col__3jHRE"};